<form #saveCommentForm="ngForm" [ngClass]="{'disabled-content': loadingSpinner}">
	<div class="add-item-block">
		<div class="area-block">
			<textarea #punchItemTextArea class="text-area" matInput placeholder="Write a comment..." [required]="true"
				minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
				[mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}"></textarea>

			<mat-icon class="cancel-item-button" (click)="hideInputItem()">close</mat-icon>
		</div>
		<div class="buttons-block">
			<button mat-button class="add-item-button" (click)="saveComment()"
				[ngClass]="{'disabledButton': !saveCommentForm.form.valid}" [disabled]="!saveCommentForm.form.valid">
				<span *ngIf="!loadingSpinner">Save</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
			<div class="space-block"></div>
			<button mat-button class="delete-item-button" (click)="deleteItem()">
				<mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
				<lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</div>
</form>